import React from 'react';

const ConfirmHardReload = ({ setConfirmHardReload, confirmHardReload, handleHardReload }) => {
  return (
    <div className="fixed top-0 z-[60] left-0 right-0 bottom-0 bg-black bg-opacity-35 min-h-screen  justify-center items-center w-full flex">
      <div className="w-1/2 h-1/2 min-h-[350px] overflow-y-auto bg-white rounded p-10 flex flex-col justify-center items-center gap-16">
      <p className="text-2xl font-montserrat text-center">
         To ensure Statgrit performs optimally, we will now refresh the browser. If you believe the event has ended, you may choose to proceed instead. Do you want to refresh the browser?
        </p>
        <div className="w-1/2 flex gap-10 items-center justify-center">
          <button
            onClick={() => setConfirmHardReload(!confirmHardReload)}
            className="w-1/3 h-20 font-bebas text-4xl rounded bg-black text-white "
          >
            No
          </button>
          <button
            onClick={() => handleHardReload()}
            className="w-1/3 h-20 font-bebas text-4xl rounded bg-primary text-white "
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmHardReload;